import Layers from "slotworks/graphics/layers/layers";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import autoplayModel from "slotworks/model/autoplay-model";

export default class NoSkipButtonBehaviour extends AbstractButtonBehaviour {

    public init() {
        Layers.SmartButton.defaultScene().execute();
        const button = Layers.SmartButton.getFlexiButton("spin");
        button.setEnabled(false);

        const autoButton = Layers.SmartButton.getFlexiButton("auto_start");
        if (autoButton) {
            autoButton.setEnabled(false);
            if(autoplayModel.autoplayDisabled) {
                autoButton.setVisible(false);
            }
        }
        const buttonAutoSpin = Layers.SmartButton.getFlexiButton("autospin");
        if(buttonAutoSpin) {
            buttonAutoSpin.setEnabled(false);
            buttonAutoSpin.setVisible(false);
        }

        const betButton = Layers.SmartButton.getFlexiButton("betbtn");
        if(betButton) {
            betButton.setVisible(false);
        }
    }

    public destroy() {

        super.destroy();
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/no-skip-button-behaviour.ts